// src/data/mock.data.contact.ts

import { cockpitGet } from '../config/cockpit';
import { Location } from '../models/Location';

type CockpitLocationItem = {
  id?: number;
  order?: number;
  name?: string;
  email?: string;
  phoneNumber?: string;
  address?: string;
  'Map Location'?: string;
  Type?: 'HQ' | 'Presence';
};

export async function getLocations(): Promise<Location[]> {
  const items: CockpitLocationItem[] =
    await cockpitGet<CockpitLocationItem[]>(
      '/api/content/items/Locations'
    );

  const sorted = [...items].sort(
    (a: CockpitLocationItem, b: CockpitLocationItem) =>
      (a.order ?? 0) - (b.order ?? 0)
  );

  return sorted.map((l: CockpitLocationItem) => ({
    name: l.name || '',
    address: l.address || '',
    contact: {
      email: l.email || '',
      phoneNumber: l.phoneNumber || '',
    },
    'Map Location': l['Map Location'],
    Type: l.Type,
  }));
}